import { Alert, TextField } from "@mui/material";
import { useSettingsContext } from "../../SettingsContext";
import { getDisplayName, getRoomName } from "../../ostertalertypes";
import { dateToStr } from "../../utils/dateutils";
import { useStepperContext } from "./StepperContext";

interface ISummary {
  bookingRequestSend: boolean;
}



export const StepSummary: React.FC<ISummary> = (props) => {
  const stepperCtx = useStepperContext();
  const settingsCtx = useSettingsContext();

  const onTextFieldChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    stepperCtx.activeBooking.forEach((res) => {
      if (stepperCtx.selectedUser) {
        // when a user is selected the admin is doing the booking => store comment in admin comment
        res.adminComment = event.target.value.trim();
      } else {
        res.userComment = event.target.value.trim();
      }
    });
  };

  const getGuestCount = () => {
    const totalGuestCount = stepperCtx.activeBooking.reduce((sum, res) => sum + res.guestCount, 0);
    return totalGuestCount === 0 ? "" : totalGuestCount;
  };


  let text = <p>Keine valide Buchung</p>;
  if (stepperCtx.activeBooking) {

    text = (
      <>
        <div className="mt-5">
          <p className="font-semibold">
            Buchung in {stepperCtx.activeBooking[0].houseName} mit insgesamt {getGuestCount()} Gästen
            {stepperCtx.selectedUser && (
              <> für Gast <b>{getDisplayName(stepperCtx.selectedUser)}</b></>
            )}
          </p>
        </div>

        {stepperCtx.activeBooking.map((app, index) => {
          return (
            <div key={index} className="bg-blue-600 mt-5 p-4 text-white font-medium  leading-tight rounded shadow-md">
              <div>
                {`${getRoomName(app.roomName, false)} von ${app.from && dateToStr(app.from)} bis ${app.to && dateToStr(app.to)}.`}
              </div>
            </div>
          );
        })}


        <TextField
          label="Kommentar an Hüttenwart"
          id={"usercomment"}
          disabled={props.bookingRequestSend}
          className="w-full my-5"
          onChange={onTextFieldChange}
          multiline
          rows={4}
        ></TextField>
        <p className="text-xs mt-5">
          Die vorläufige Buchung wird an den Hüttenwart weitergeleitet. Nach Bestätigung durch den Hüttenwart erhalten
          Sie eine Bestätigungsmail und die Buchung ist anschließend bindend.
        </p>
        <Alert severity="info" className="mt-5">
          <div className="ml-5">
            <li>
              {`Um anderen Mitglieder ebenfalls eine Chance für eine Buchung zu geben, ist die nächste elektronische Buchung
              erst wieder in ${settingsCtx.settings.reservation.bookingRestrictionDays} Tagen möglich. `}
              <b>Stellen Sie daher jetzt sicher, dass alle benötigten Zimmer in dieser Buchung enthalten sind. </b>
              Falls eine weitere Buchung innerhalb der Sperre gewünscht ist (zum Beispiel wegen
              aktuellem Leerstand in den Häusern), bitte telefonisch oder per E-Mail direkt beim Hüttenwart buchen.
            </li>
            <li>
              Eine Buchung kann nur von Vereinsmitgliedern vorgenommen werden und setzt deren Mitreise voraus.
            </li>
          </div>
        </Alert>
      </>
    );
  }

  return text;
};
